module.exports = "/_next/static/images/chest-tokens-69759394cc26f094a0ebd9618707fee2.png";